export default __webpack_public_path__ + "static/media/ornament_5.ea7a11ad.png";